<!-- <div style="padding: 24px;">
  <div id="drop-zone" (dragover)="active=1;" (dragleave)="active=0;" (drop)="active=0;" [ngClass]="{'active':active}">
    <label for="input-file{{id}}">Drop files here or click to upload</label>
  </div>
  <input [(ngModel)]="file" (change)="fileInputChanged($event.target.files)" id="input-file{{id}}" type="file"
    [multiple]="multiple" style="display:none;">

  <div class="result" *ngIf="result.length">
    <ng-container *ngFor="let x of result;let i=index;">
      <div class="row" *ngIf="x && x.status == 1">
        <label class="col-md-10">
          {{x.file_title}}
        </label>
        <div class="col-md-2">
          <i (click)="removeFile(x)" class="fa fa-trash"></i>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="row mt-4">
    <div class="col-md-12">
      <button class="float-right ml-1 btn btn-sm btn-info" [mat-dialog-close]="result">
        Done
      </button>
      <button class="float-right ml-auto btn btn-sm btn-danger" (click)="cancel()">
        Cancel
      </button>
    </div>
  </div>
</div> -->
<div mat-dialog-title>
  Attachments
</div>
<div mat-dialog-content>
  <div id="drop-zone" (dragover)="active=1;" (dragleave)="active=0;" (drop)="active=0;" [ngClass]="{'active':active}">
    <label for="input-file{{id}}" class="m-0 py-2" style="color:#666;">
      Drop
      <span *ngIf="multiple">
        files
      </span>
      <span *ngIf="!multiple">
        a file
      </span>
      here or click to upload
    </label>
  </div>
  <input [(ngModel)]="file" (change)="fileInputChanged($event.target.files)" id="input-file{{id}}" type="file" [multiple]="multiple"
    style="display:none;">

  <div class="result" *ngIf="result.length">
    <ng-container *ngFor="let x of result;let i=index;">
      <div class="row" *ngIf="x && x.status == 1">
        <label class="col-md-10">
          {{x.file_title}}
        </label>
        <div class="col-md-2">
          <i (click)="removeFile(x)" class="fa fa-trash"></i>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<div class="mat-dialog-actions">
  <button class="btn btn-sm btn-danger" (click)="cancel()">
    Cancel </button>
  <button class="ml-1 btn btn-sm btn-info" [mat-dialog-close]="result">
    Done
  </button>
</div>